<!--customSnackbarButtonContainer will be shown next to text if there is just 1 button present,
unless we're dealing with an info snackbar, in which case it'll always be on the bottom-->
<div id="customSnackbarContainer"
  class="actionButtonsOnBottom">
  <div id="customSnackbarContentContainer">
    @if (getLeftIcon()) {
      <mat-icon [svgIcon]="getLeftIcon()"
      id="customSnackbarLeftIcon"></mat-icon>
    }
    <div id="customSnackbarText">
      @if (data.title) {
        <span id="customSnackbarTitle">{{ data.title }}</span>
      }
      <span id="customSnackbarMessage" [innerHTML]="data.userFriendlyMessage"></span>
    </div>
  </div>

  <div id="customSnackbarButtonContainer">
    @if (!data.dismissButton?.hide) {
      <button id="customSnackbarCancelButton"
        mat-flat-button
        (click)="closeSnackbar()">{{data.dismissButton?.text || ('DISMISS' | translate)}}
      </button>
    }

    @if (data.detailedInfoFromBE?.length) {
      <button id="customSnackbarShowDetailsButton"
        mat-flat-button
        (click)="showDetailsPopup()">{{ 'CUSTOM_SNACKBAR.SHOW_DETAILS' | translate }}
      </button>
    }

    @for (actionButton of (data.actionButtons || []); track actionButton) {
      <button
        class="customSnackbarActionButton" mat-flat-button
      (click)="closeSnackbarWithAction(actionButton.action)">{{actionButton.text}}</button>
    }
  </div>
</div>